import { BoltRounded, CancelRounded, CheckCircleRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import React from 'react';

function ReplacementOptimizationHeader({ recommendation }) {
    const theme = useTheme();

    var headerText = 'Recommended Replacement';
    if (recommendation.status === 'accepted') {
        headerText = 'Replacement Accepted';
    } else if (recommendation.status === 'rejected') {
        headerText = 'Replacement Declined';
    }

    return (
        <Stack direction='row' spacing={0.5} alignItems='center'>
            { recommendation.status === 'accepted' &&
                <CheckCircleRounded
                    fontSize='small'
                    style={{ color: `${theme.palette.green.main}`, marginLeft: '-5px' }}
                />
            }
            { recommendation.status === 'rejected' &&
                <CancelRounded
                    fontSize='small'
                    style={{ color: `${theme.palette.red.main}`, marginLeft: '-5px' }}
                />
            }
            { recommendation.status === 'open' &&
                <BoltRounded fontSize='small' style={{ marginLeft: '-5px' }} />
            }
            <Typography variant='bold' sx={{ fontSize: '14px' }}>{headerText}</Typography>
        </Stack>
    );
}

export default ReplacementOptimizationHeader;
